import './vinelandhospitality/style';
import FormStructure from './vinelandhospitality/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/Dev/web_inquiry/inquiry-renderer/client_forms/includes.js